/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Frame_Rate_HelpInputs */

const en_source_frame_rate_help = /** @type {(inputs: Source_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the frame rate of your source material`)
};

const fr_source_frame_rate_help = /** @type {(inputs: Source_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez la fréquence d’images de votre source`)
};

const de_source_frame_rate_help = /** @type {(inputs: Source_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Bildrate Ihres Quellmaterials.`)
};

const it_source_frame_rate_help = /** @type {(inputs: Source_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il frame rate del materiale sorgente`)
};

const ru_source_frame_rate_help = /** @type {(inputs: Source_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите частоту кадров исходного материала.`)
};

const es_source_frame_rate_help = /** @type {(inputs: Source_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione la velocidad de fotogramas de su material de origen`)
};

const zh_cn2_source_frame_rate_help = /** @type {(inputs: Source_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择源素材的帧速率`)
};

const ja_source_frame_rate_help = /** @type {(inputs: Source_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソース素材のフレームレートを選択します`)
};

const hi_source_frame_rate_help = /** @type {(inputs: Source_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने स्रोत सामग्री की फ्रेम दर चुनें`)
};

const pt_pt2_source_frame_rate_help = /** @type {(inputs: Source_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a taxa de quadros do seu material de origem.`)
};

/**
* | output |
* | --- |
* | "Select the frame rate of your source material" |
*
* @param {Source_Frame_Rate_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_frame_rate_help = /** @type {((inputs?: Source_Frame_Rate_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Frame_Rate_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_source_frame_rate_help(inputs)
	if (locale === "de") return de_source_frame_rate_help(inputs)
	if (locale === "it") return it_source_frame_rate_help(inputs)
	if (locale === "ru") return ru_source_frame_rate_help(inputs)
	if (locale === "es") return es_source_frame_rate_help(inputs)
	if (locale === "zh-CN") return zh_cn2_source_frame_rate_help(inputs)
	if (locale === "ja") return ja_source_frame_rate_help(inputs)
	if (locale === "hi") return hi_source_frame_rate_help(inputs)
	if (locale === "pt-PT") return pt_pt2_source_frame_rate_help(inputs)
	return en_source_frame_rate_help(inputs)
});